const CustomRequestDetailBreadcrumbConstant = [
  {
    title: "Custom Requests",
    link: "/user/custom_requests",
  },
  {
    title: "Request Details",
    link: "",
    is_active: true,
  },
];

export default CustomRequestDetailBreadcrumbConstant;
